// extracted by mini-css-extract-plugin
export default {"button1":"Login_button1__9orKs","loginButton":"Login_loginButton__FkADa"};